
export enum ReturnType {
    Return = 'Return',
    Buyout = 'Buyout'
}
